// extracted by mini-css-extract-plugin
module.exports = {"colSlider":"bW_fR","arrowsContainer":"bW_fS","arrowBtn":"bW_fT","fullScreen":"bW_fV"};